var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('navbar'),_c('section',{staticClass:"hero is-ligth is-fullheight-with-navbar"},[_c('div',{staticClass:"hero-body"},[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }